import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class OrientationService {
    constructor(private http: HttpClient) { }

    getStudentOrientationSemesters(studentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/GetStudentOrientationSemesters?studentId=${studentId}`);
    }

    getStudentOrientationSemester(orientationSemesterStudentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/GetStudentOrientationSemester?orientationSemesterStudentId=${orientationSemesterStudentId}`);
    }

    getOrientationSemesterStudentSystemCheckListItems(orientationSemesterId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/GetOrientationSemesterStudentSystemCheckListItems?orientationSemesterId=${orientationSemesterId}`);
    }

    insertOrUpdatePreArrivalForm(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalOrientation/InsertOrUpdatePreArrivalForm`, saveModel);
    }

    getPreArrivalFormDetails(orientationSemesterStudentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/GetPreArrivalFormDetails?orientationSemesterStudentId=${orientationSemesterStudentId}`);
    }

    submitPreArrivalForm(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalOrientation/SubmitPreArrivalForm`, saveModel);
    }

    getOrientationSemesterStudentCheckListItems(orientationSemesterStudentId: number, studentAge: number, isHousingStudent: boolean, isReturningStudent: boolean, funnelId: number, providerId?: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/OrientationSemesterStudentCheckListItems?orientationSemesterStudentId=${orientationSemesterStudentId}&studentAge=${studentAge}&funnelId=${funnelId}&providerId=${providerId}&isHousingStudent=${isHousingStudent}&isReturningStudent=${isReturningStudent}`);
    }

    insertOrUpdateOrientationSemesterStudentCheckListItem(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalOrientation/InsertOrUpdateOrientationSemesterStudentCheckListItem`, saveModel);
    }

    markNonDocumentOrientationSemesterStudentCheckListItemAsCompleted(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalOrientation/MarkNonDocumentOrientationSemesterStudentCheckListItemAsCompleted`, saveModel);
    }

    getOrientationCheckListItemVideo(orientationCheckListItemId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalOrientation/OrientationCheckListItemVideo?orientationCheckListItemId=${orientationCheckListItemId}`);
    }
}